module.exports = __webpack_public_path__ + "fonts/Evogria.ec97ae08.woff";